import { Link } from "@/components/LocalLink";
import { JARS, IMAGES, productPath } from "@/data/catalog";
import { PageShell, usePageMeta } from "@/components/PageShell";
import { useSite } from "@/context/SiteContext";

const WILD = { foresters_guard: "Wild-gathered after first frost", trailhead_vigor: "Cultivated, never wild-taken", riverbend_calm: "Cultivated", grey_muzzle_reserve: "Cultivated" };
const WHERE = { foresters_guard: "Fallen birch & poplar" };

export const BatchNotice = () => (
  <div className="panel lookup" data-testid="batch-notice">
    <div><div className="eyebrow">Batch lookup</div><h2 className="sec" style={{ marginBottom: 6 }}>Check your jar</h2><p className="muted">Enter the number on the base of your jar to see where it grew, when it was gathered and its lab certificate.</p></div>
    <div><p style={{ color: "#E9B872", fontSize: 14 }}>The first batch results will be published here when ordering opens.</p></div>
  </div>
);

export default function OurStandard() {
  usePageMeta("Our Standard · Dirty Paws Apothecary", "Every ingredient named. Every batch numbered. How we source, make and record each jar.");
  const { sourcingWhere } = useSite();
  return (
    <PageShell testid="standard-page" page="standard">
      <div className="wrap"><div className="page-head"><div className="eyebrow">Our Standard</div><h1>Every ingredient named.<br />Every batch numbered.</h1><p>Four rules every jar has to pass, where each mushroom comes from, and (from the first batch on) the lab results for your jar.</p></div></div>
      <div data-testid="standard-rows">
        <div className="pr"><img src={IMAGES.gather} alt="Gathering turkey tail from a fallen log" /><div className="t"><div className="n">01</div><h3>The whole story</h3><p>Every ingredient named, every source stated. If we can't say where it grew, it doesn't go in the jar.</p></div></div>
        <div className="pr rev"><div className="t"><div className="n">02</div><h3>Small runs</h3><p>Batches small enough to know personally. The batch number is on the base of every jar.</p></div><img src={IMAGES.measure} alt="A measure of mushroom powder on the apothecary bench" /></div>
        <div className="pr"><img src={IMAGES.shelf} alt="Amber jars on the apothecary shelf" /><div className="t"><div className="n">03 · 04</div><h3>No theatre. The dogs decide.</h3><p>No miracle claims, no borrowed science. And every preparation passes the four-dog panel, which is uncompromising and usually asleep until noon.</p></div></div>
      </div>
      <div className="wrap"><div className="src">
        <div className="eyebrow">Where it comes from</div><h2 className="sec">Sourcing, jar by jar</h2>
        <table data-testid="sourcing-table"><tbody>
          <tr><th>Jar</th><th>Mushroom</th><th>Wild or cultivated</th><th className="hide-m">Where</th></tr>
          {JARS.map((p) => (
            <tr key={p.id} data-testid={`sourcing-row-${p.id}`}>
              <td><Link to={productPath(p)}><b>{p.name}</b></Link></td>
              <td>{p.sourcing.mushroom.split(" · ")[0]} · <i>{p.sourcing.mushroom.split(" · ")[1]}</i></td>
              <td>{WILD[p.id]}</td>
              <td className="hide-m" data-testid={`sourcing-where-${p.id}`}>{sourcingWhere?.[p.id] || WHERE[p.id] || "—"}</td>
            </tr>
          ))}
        </tbody></table>
        <div id="batch"><BatchNotice /></div>
      </div></div>
    </PageShell>
  );
}
